// John Eldhose 20180629
const ResetCart = () => ({
  type: 'RESET_CART'
});

export default ResetCart;



// WEBPACK FOOTER //
// ./src/actions/ResetCart.js